<!--
  - Sun-Sky  2022/5/16 下午5:37
  -->

<template>
  <div class="box2">
    <!--    <back @change="$router.back()"/>-->
    <user-content-header :data="userInfo"/>
    <user-content-tab @change="tabIndexChange"/>
    <user-content-list :tab-index="tabIndex" :live-list-data="liveListData" :check-list-data="checkListData"/>
    <footer-number type="1"/>
    <!--    二次确认-->
    <van-dialog v-model="showAffirm" :showConfirmButton="false">
      <div style="background: #f5f5f5">
        <div class="showAffirm-boxs">
          <img @click="goUserInfo" class="colse"
               src="https://astl-2.oss-cn-beijing.aliyuncs.com/2021/1008/%E9%94%99%E8%AF%AF%403x.png" alt="">
          <img src="https://swy-media.oss-cn-beijing.aliyuncs.com/681636707025_.pic_hd.jpg" alt="">
          <div class="agreementDoctor">
            <div style="margin-right: 4px;margin-top: 2px">
              <van-checkbox icon-size="18px" checked-color="#2BA1CD" v-model="checked" shape="square"></van-checkbox>
            </div>
            <div>
              <span>我已阅读并同意签署</span>
              <span style="color:#0090C5;" @click="$router.push({ path: '/agreementDoctor' })">《个人信息披露知情同意》</span>
            </div>
          </div>
        </div>
        <div class="showAffirm-btn">
          <div @click="save">同意</div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import UserContentHeader from "@/views/user/UserContentHeader";
import UserContentTab from "@/views/user/UserContentTab";
import Back from "@/components/back/Back";
import UserContentList from "@/views/user/UserContentList";
import {wxShare} from "@/common/js/wx";
import FooterNumber from "@/components/footer/footerNumber";

export default {
  name: "userContent",
  components: {FooterNumber, UserContentList, Back, UserContentTab, UserContentHeader},
  data() {
    return {
      checked: false,
      showAffirm: false,
      tabIndex: 0,
      checkListData: [],
      liveListData: [],
      userInfo: {},
    }
  },
  activated() {
    if (localStorage.getItem('IAgree') === 'NO') {
      this.showAffirm = true
    } else {
      this.showAffirm = false
    }
  },
  mounted() {
    this.getCheckList()
    this.getFavoriteList()
    this.getUserInfo()
    wxShare('个人中心')
  },
  methods: {
    goUserInfo() {
      // 如果是重新签署的用户 可以关闭 弹框 继续浏览内容
      if(localStorage.getItem('cXQS') === 'YES') {
        localStorage.setItem('IAgree', 'YES')
      }
      this.$router.back()
    },
    save() {
      if (!this.checked) {
        this.$toast('请勾选并阅读知情同意书')
        return
      }
      let userId = localStorage.getItem('userId-school')
      let params = {
        userid: userId,
        value1: 'YES：' + new Date().getTime(),
        sign2022: localStorage.getItem('cXQS') === 'YES' ? 1 : 0
      }
      this.$http.post(this.$api.userInfoUpdate, params).then((res) => {
        let {code, message} = res
        if (code === 0) {
          this.close()
          this.showAffirm = false
          localStorage.setItem('IAgree', 'YES')
          this.$notify({
            type: 'success',
            message: '保存成功',
          })
        } else {
          this.$notify(message)
        }
      })
    },
    close() {
      let url = localStorage.getItem('history_url')
      if (url) {
        this.$router.push({path: url})
      } else {
        this.$router.push({
          path: '/user/content'
        })
      }
    },
    tabIndexChange(val) {
      this.tabIndex = val
    },
    getUserInfo() {
      let userId = localStorage.getItem('userId-school')
      this.$http.get(this.$api.getUserInfo + userId).then(res => {
        let {code, data} = res
        if (code === 0) {
          if (!data.value1 || data.value1.indexOf('NO') >= 0) {
            localStorage.setItem('IAgree', 'NO')
            this.showAffirm = true
          }
          if (data.value1.indexOf('需要重新签署') >= 0) {
            localStorage.setItem('IAgree', 'NO')
            localStorage.setItem('cXQS', 'YES')
            this.showAffirm = true
          } else {
            localStorage.setItem('cXQS', 'NO')
          }
          this.userInfo = data
        }
      })
    },
    getCheckList() {
      // 获取观看记录
      let params = {
        pageNum: 1,
        pageSize: 100,
        params: {
          userid: localStorage.getItem('userId-school')
        }
      }
      this.$http.post(this.$api.videoCheckList, params).then(res => {
        this.checkListData = res.data.content
      })
    },
    getFavoriteList() {
      // 获取收藏记录
      let params = {
        pageNum: 1,
        pageSize: 100,
        params: {
          userid: localStorage.getItem('userId-school')
        }
      }
      this.$http.post(this.$api.favorite.list, params).then(res => {
        this.liveListData = res.data.content
      })
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .van-dialog {
    background: #F5F5F5;
  }
}
.agreementDoctor {
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  padding: 0 20px;
  text-align: left;
}
.showAffirm-boxs {
  position: relative;
  background: #F5F5F5;

  .colse {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 30px;
  }

  img {
    width: 100%;
    margin-bottom: 60px;
  }
}

.showAffirm-btn {
  width: 100%;
  margin-top: 60px;
  display: flex;
  flex-direction: row;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0 40px;
  margin-bottom: 60px;

  div {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    background: #FFFFFF;
    height: 90px;
    border-radius: 40px;
    border: 2px solid #2BA1CD;
    color: #2BA1CD;
    font-size: 40px;
    font-weight: bold;
  }
}

.box2 {
  //background: #f5f5f5;
  min-height: 100%;
}
</style>
